<template>
    <div>
        <EmcBaseProgressBar v-if="isLoading" />
            <v-treeview
                    ref="tree"
                    :active.sync="active"
                    :items="campuses"
                    :load-children="fetchItems"
                    :open.sync="open"
                    activatable
                    item-children="children"
                    color="primary"
                    :open-on-click="true"
                    transition
                    item-key="key"
                    return-object
                    @update:active="selectItem($event)"
                >
                    <template slot="label" slot-scope="{ item }">
                        
                        <v-tooltip v-if="item.level == 3" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">{{ item.name }}</span>
                                <small v-if="item.grid.periodicity_type_id != 1">
                                    <br/>{{ item.grid.periodicity_type.name }} - ({{ item.grid.classes_dates.length }})
                                </small>
                            </template>
                            <span>
                                {{ item.name }}
                                <small v-if="item.grid.teacher_id"><br/>{{ item.grid.teacher.name }}</small>
                            </span>
                        </v-tooltip>
                        <span v-else> {{ item.name  }}</span>

                        

                    </template>
                </v-treeview>
    </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    name: 'SysGridTreeView',
    data: function() {
        return {
            campuses: '',
            active: [],
            open: [],
            search: '',
            isLoading: false,
        }
    },
    props: {
        filters: { type: Object, required: false },
    },
    created() {
        this.getCampuses()
    },
    methods: {
        ...mapActions('domainCampus', ['ActionGetCampuses']),
        ...mapActions('domainShift', ['ActionGetShifts']),
        ...mapActions('domainGroup', ['ActionGetGroups']),
        ...mapActions('domainGrid', ['ActionGetGrids']),
        async fetchItems (item) {        
            switch (item.level) {
                case 0:
                    return await this.getShifts(item);
                case 1:
                    return await this.getGroups(item);
                case 2: 
                    return await this.getGrids(item)
            }
        },
        getCampuses(){
            
            this.campuses = [];
            this.isLoading = true
            let payload = {}

            if(this.filters && this.filters.campus ) {
                payload = {
                    ...payload,
                    ...this.filters.campus
                }
            }

            this.ActionGetCampuses(payload)
                .then((res) => {
                    res.data.map(campus => {

                        const item = {
                            id: campus.id,
                            key: campus.id,
                            level: 0,
                            name: campus.name,
                            children: []
                        }

                        this.campuses = [
                            ...this.campuses,
                            item
                        ]

                    });
                })
                .finally(() => {
                    this.isLoading = false
                });
        },

        async getGrids(group) {
            
            let payload = {
                noResource: true,
                withClassesDate: true,
                columns: 'classes_dates,id,discipline_name,group_id,work_load_type_id,periodicity_type_id,work_time_id',
                with: 'workLoadType|periodicity_type',
                find_columns: { group_id: group.id },
            };

            if(this.filters && this.filters.grid ) {
                payload = {
                    ...payload,
                    ...this.filters.grid
                }
            }

            return this.ActionGetGrids(payload)
                .then((res) => {

                    res.data.map(grid => {

                        const item = {
                            id:         grid.id,
                            group_id:   group.id,
                            key:        group.id + '|' + grid.id, 
                            level:      3, 
                            name:       grid.discipline_name + ' (' + grid.work_load_type.initials + ')',
                            classes_dates:    grid.classes_dates,
                            classes:    grid.classes,
                            grid:       grid,
                            parent:     group,
                        }

                        group.children = [
                            ...group.children,
                            item
                        ]
                    });
                   
                })
        },

        async getShifts(campus) {  

            let payload = {
                columns: 'id,name',
		        column_order: 'name'
            };

            if(this.filters && this.filters.shift ) {
                payload = {
                    ...payload,
                    ...this.filters.shift
                }
            }

            return this.ActionGetShifts(payload)
                .then((res) => {
                    res.data.map(shift => {

                        const item = {
                            id: shift.id,
                            campus_id: campus.id,
                            key: campus.key + '|' + shift.id,
                            level: 1,
                            name: shift.name,
                            children: []
                        }

                        campus.children = [
                            ...campus.children,
                            item
                        ];

                    });
            })
        },
        async getGroups(shift){

            let payload = {
                columns: 'id,name,campus_id',
		        column_order: 'name',
		        find_columns: { shift_id: shift.id, campus_id: shift.campus_id },
            }

            if(this.filters && this.filters.group ) {
                payload = {
                    ...payload,
                    ...this.filters.group
                }
            }

            return this.ActionGetGroups(payload)
                .then((res) => {
                    
                    res.data.map(group => {
                        
                        const item = {
                            id: group.id,
                            key: shift.key + '|' + group.id,
                            level: 2,
                            name: group.name,
                            children: [],
                            
                        }

                        shift.children = [
                            ...shift.children,
                            item
                        ];
                        
                    })
                    
                });

        },

        selectItem(item){
            
            if(item && item.length > 0){
                this.$emit('selected', item[0]);
            }
            
        },

    }
}
</script>